import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { msalInstance, scopes } from '@/services/msal';

export const apiSlice = createApi({
	reducerPath: 'api',
	tagTypes: [
		'ACTIONS',
		'NOTIFICATIONS',
		'TASKS',
		'ORGANIZATIONS',
		'USERS',
		'SETTINGS',
		'SYSTEM_STATUS',
		'DASHBOARD_LAYOUTS',
		'ORGANIZATIONS_SHIFT_ACTIVITY_TYPES',
	],
	baseQuery: fetchBaseQuery({
		baseUrl: `${import.meta.env.VITE_API_BASE_URL}`,
		prepareHeaders: async (headers) => {
			const account = msalInstance.getAllAccounts()[0];
			if (account) {
				const accessTokenResponse = await msalInstance.acquireTokenSilent({
					scopes: scopes,
					account: account,
				});

				if (accessTokenResponse) {
					const token = accessTokenResponse.accessToken;

					if (headers && token) {
						headers.set('Authorization', `Bearer ${token}`);
					}
				}
			}

			return headers;
		},
	}),

	endpoints: () => ({}),
});
